package co.maytes.standupbot.dashboard.features.settings

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.shared.dto.auditlog.AuditLogEntryDto

val AuditLogColumns = listOf(
    LogTableColumn("Who", width = "12rem"),
    LogTableColumn("What", width = "14rem"),
    LogTableColumn("Target", width = "12rem"),
    LogTableColumn("Detail", width = "100%"),
    LogTableColumn("When (UTC)", end = true),
)

@Composable
fun AuditLogRow(entry: AuditLogEntryDto) {
    var expanded by remember { mutableStateOf(false) }
    val target = AuditLogView.targetLabel(entry)
    val summary = entry.summary?.takeIf { it.isNotBlank() }

    LogTableRow(
        columnCount = AuditLogColumns.size,
        expanded = expanded,
        onToggle = { expanded = !expanded },
        detail = { LogDetailList(AuditLogView.detailRows(entry)) },
    ) {
        LogCell {
            LogCellText(
                text = AuditLogView.actorLabel(entry),
                color = if (entry.actorUserId == null) Palette.textSecondary else Palette.textPrimary,
            )
        }
        LogCell { LogCellText(text = entry.action, mono = true) }
        LogCell {
            if (target == null) {
                LogCellMissing()
            } else {
                LogCellText(text = target, mono = true, clip = true, capped = true, color = Palette.textSecondary, title = target)
            }
        }
        LogCell(flow = LogCellFlow.Fill) {
            if (summary == null) {
                LogCellMissing()
            } else {
                LogCellText(text = summary, clip = true, color = Palette.textSecondary, title = summary)
            }
        }
        LogCell(end = true) {
            LogCellText(
                text = LogTimeFormat.minutes(entry.createdAt),
                color = Palette.textSecondary,
                title = entry.createdAt.toString(),
            )
        }
    }
}
